import { reactRoute } from '../../../../../../../utils/routing/reactRoute'

/* The transaction drawer is mounted on other pages too, but only the transactions table should use URL to mark transactionId */
export const isTransactionsPagePath = (pathname: string): boolean =>
  !!pathname && pathname.endsWith(`/${reactRoute.organization.transactions.getMainRoute()}`)
